import { Box, Card, CardContent, Typography, useMediaQuery,Grid, Divider, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, CircularProgress  } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";


import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import { IconButton, Menu, MenuItem, Button } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import noRecordImage from './no_clients.png'; //All Lowercase with underscore

import Tile from './ClientTile';

import React, { useState, useEffect } from 'react';
import { collection, onSnapshot, doc,writeBatch, updateDoc,setDoc, addDoc, deleteDoc, getDocs, query, where } from 'firebase/firestore';
import {db} from '../../firebaseConfig';

import {generateUniqueId} from '../../common/ItemNumberGenerator'; 

import ClientInputModal from './ClientInputModal';
import ClientDrawerModal from './ClientDrawerModal';

import { styled } from '@mui/material/styles';

import backgroundImage from './../../images/application-bg-images/app-bg-image.png';
import backgroundImageMobile from './../../images/application-bg-images/app-bg-image-mobile.png';

import { logToast } from '../../common/ToastMessageLogger';

import { useUser } from "../../common/UserContext";
import { useApplicationMode } from "../../common/ApplicationModeContext";

const Clients = ({ searchTerm }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { appUserAccountNumber } = useUser();
  const { applicationMode } = useApplicationMode();

  const tilesDisplayCount = 8;

  const [clients, setClients] = useState([]);
  
  const [visibleCount, setVisibleCount] = useState(tilesDisplayCount);
  const handleOpenModal = () => { setEditingClient(null); setShowModal(true); };
  const handleCloseModal = () => setShowModal(false);
  const [showModal, setShowModal] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editingClient, setEditingClient] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [dependenciesAlertOpen, setDependenciesAlertOpen] = useState(false);

  const [deletionDependencies, setDeletionDependencies] = useState([]);

  const [collectionModalOpen, setCollectionModalOpen] = useState(false);
  const [missingCollections, setMissingCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);

  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteSelectionModel, setDeleteSelectionModel] = useState([]);
  const [deleteAlertOpen, setDeleteAlertOpen] = useState(false);

  const [selectedIdsToDelete, setSelectedIdsToDelete] = useState([]);
  const [selectedIdsNotToDelete, setSelectedIdsNotToDelete] = useState([]);

  const [showTestModeDialog, setShowTestModeDialog] = useState(false);
  const [suppressTestModeWarning, setSuppressTestModeWarning] = useState(
    localStorage.getItem('suppressTestModeSaveWarning') === 'true'
  );

  const [selectedClient, setSelectedClient] = useState(null);

  //

  const columns = [
	{ field: "firstName", headerName: "First Name"},
	{ field: "lastName", headerName: "Last Name"},
	{ field: "email", headerName: "Email"},
	{ field: "phone", headerName: "Phone"},
	{ field: "address", headerName: "Address"},
	{ field: "isActive", headerName: "Is Active"},
	{ field: "loyaltyPoints", headerName: "Loyalty Points"},
	{ field: "preferredContactMethod", headerName: "Preferred Contact Method"},
	{ field: "referralSource", headerName: "Referral Source"},
	{ field: "membershipStatus", headerName: "Membership Status"},
	{ field: "notes", headerName: "Notes"},
	{ field: "specialPreferences", headerName: "Special Preferences"},
	{ field: "newsletterOptIn", headerName: "Newsletter Opt-In"},
	{ field: "clientNumber", headerName: "clientNumber"},
	{ field: "id", headerName: "id"},
];



  
  

  const stringToColorLight = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xFF;
      // Ensuring that the color values are always light by adding a base value of 127
      const lightValue = ((value + 127) % 128) + 127;
      color += ('00' + lightValue.toString(16)).substr(-2);
    }
    return color;
  };
  
  
  const stringToColorDark = (str) => {
    
    return stringToColorLight(str); // We will use the same colors
  };

  
  
  
    useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const idFromQuery = urlParams.get("id");

  // Only run if there's an ID in the URL and tasks are already loaded
  if (idFromQuery && !loading && clients.length > 0) {

    const matchedRecord = clients.find(client => client.id === idFromQuery);
    window.history.replaceState({}, document.title, window.location.pathname);
    if (matchedRecord) {
      handleOpenEdit(idFromQuery);
    }
  }
}, [loading, clients]);


  useEffect(() => {
    if (!appUserAccountNumber || !applicationMode) return; // Ensure both values are available

      const clientsRef = collection(db, "clients");
      const clientsQuery = query(clientsRef, 
        where("appAccountNumber", "==", appUserAccountNumber),
        where("applicationMode", "==", applicationMode)
      );
    
      const unsubscribe = onSnapshot(clientsQuery, (snapshot) => {
        const clientsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
     

      setClients(clientsData);
      
      //

      setLoading(false); 

    }, (error) => {
      setLoading(false);
      
      alert("Error fetching clients: ", error);
    });

    return () => unsubscribe();
  }, [appUserAccountNumber, applicationMode]); // Re-run when either value changes


  
  const handleSaveClient = (client) => {
    if (editingClient && editingClient.id) {
      setClients(prevClients => prevClients.map(c => c.id === client.id ? client : c));
      saveClientToDB(client);
    } else {
      setClients(prevClients => [...prevClients, { ...client, id: prevClients.length + 1 }]);
      addClientToDB(client);
    }
    setShowModal(false);
    setEditingClient(null);

    if (applicationMode === 'test' && !suppressTestModeWarning) {
      setShowTestModeDialog(true);
    }
  };

  const saveClientToDB = async (client) => {
    const clientRef = doc(db, "clients", client.id);
    await updateDoc(clientRef, client);
    logToast("The record has been saved.");
  };

  const addClientToDB = async (client) => {
    
    const clientNumber= await generateUniqueId("clients",appUserAccountNumber);
    client.clientNumber = clientNumber;

    client.appAccountNumber = appUserAccountNumber;
    client.applicationMode = applicationMode;
    
    const docRef = doc(db, 'clients', clientNumber);  
    await setDoc(docRef,client);
    logToast("The record has been added.");

  };

  const handleDeleteSelected = async () => {
    if (deleteSelectionModel.length === 0) {
      setDeleteAlertOpen(true);
      return;
    } else 
    {

      setProcessing(true);
      const idsToDelete = [];
      const idsNotToDelete = [];

      let allDeletionDependencies = [];

      //1. Identify Ids to Delete
      for (const id of deleteSelectionModel)
      {
        const dependencies = await hasDependencies(id);
    
        allDeletionDependencies = allDeletionDependencies.concat(dependencies); 

        setProcessing(false);
        
        if (dependencies.length === 0) {
          idsToDelete.push(id);
        } else 
        {
          idsNotToDelete.push(id);
        }
      }

      let uniqueDeletionDependencies = [...new Set(allDeletionDependencies)];

      setDeletionDependencies(uniqueDeletionDependencies);

      setSelectedIdsToDelete(idsToDelete);
      setSelectedIdsNotToDelete(idsNotToDelete);

      //2. Delete allowed ids

      setDeleteConfirmOpen(true);
      setProcessing(false);

    }

  };

  const handleAlertClose = () => {
    setDeleteAlertOpen(false);  
  };

  
  const handleCancelDelete = () => {
      
      setDeleteConfirmOpen(false);
      setSelectedIdsToDelete([]);
      setSelectedIdsNotToDelete([]);
      setDeletionDependencies([]);
      
  };


  const confirmDeleteSelected = async () => {
    try {
      const batch = writeBatch(db);
      selectedIdsToDelete.forEach(id => {
        const docRef = doc(db, "clients", id);
        batch.delete(docRef);
      });

      await batch.commit();
      logToast("The records have been delete.");

      setDeleteSelectionModel([]);
      setDeleteConfirmOpen(false);
      setSelectedIdsToDelete([]);
      setSelectedIdsNotToDelete([]);
      setDeletionDependencies([]);

    } catch (error) {
      console.error("Error deleting documents: ", error);
    }
  };

  
  const hasDependencies = async (id) => {
    const dependencies = [];
  
    try {
      
      
                
                const eventsClientQuery = query(
                    collection(db, 'events'),
                    where("appAccountNumber", "==", appUserAccountNumber),
                    where('clientId', '==', id)
                );
                
                const eventsClientSnapshot = await getDocs(eventsClientQuery);
                
                if (!eventsClientSnapshot.empty) {
                    dependencies.push("Events");
                }
                
                

                
                const bookingsClientQuery = query(
                    collection(db, 'bookings'),
                    where("appAccountNumber", "==", appUserAccountNumber),
                    where('clientId', '==', id)
                );
                
                const bookingsClientSnapshot = await getDocs(bookingsClientQuery);
                
                if (!bookingsClientSnapshot.empty) {
                    dependencies.push("Bookings");
                }
                
                

                
                const invoicesClientIDQuery = query(
                    collection(db, 'invoices'),
                    where("appAccountNumber", "==", appUserAccountNumber),
                    where('clientId', '==', id)
                );
                
                const invoicesClientIDSnapshot = await getDocs(invoicesClientIDQuery);
                
                if (!invoicesClientIDSnapshot.empty) {
                    dependencies.push("Invoices");
                }
                
                

  
    } catch (error) {
      console.error("Error checking dependencies:", error);
      return ["error"]; // Return an array with "error" to prevent deletion in case of an issue
    }
  
    return dependencies; // Return array of collection names with dependencies
  };
  
  const handleDeleteSingleItem = async (id) => {
  
    try
    {
      
      setProcessing(true);

      const dependencies = await hasDependencies(id);
    
      setProcessing(false);
      
      if (dependencies.length === 0) {
        setDeleteId(id);
        setConfirmOpen(true);
      } else {
        setDeleteId(id);
        setDeletionDependencies(dependencies);
        setDependenciesAlertOpen(true);
      }

    } catch(error)
    {
      setProcessing(false);
    }
  };

  const handleDependenciesAlertClose = async () => {
    
      setDependenciesAlertOpen(false);
      setDeletionDependencies([]);
    
  };


  const handleConfirmClose = async () => {
    try {
      if (deleteId) await deleteDoc(doc(db, "clients", deleteId));
      setConfirmOpen(false);
      setDeleteId("");
      logToast("The record has been delete.");
    } catch (error) {
      console.error("Error deleting document: ", error);
    }
  };

  const handleCancelClose = () => {
    setConfirmOpen(false);
    setDeleteId("");
  };

  const openClientDrawer = (id) => {

    const rowIndex = filteredClients.findIndex(row => row.id === id);

    const clientId = id;

   // setSelectedRowIndex(rowIndex);

    const selectedClient = clients.find(p => p.id === clientId);
    if (selectedClient !== null && selectedClient != undefined)
    {  
      setSelectedClient(selectedClient);
      setDrawerOpen(true);
    }
  };

  const handleDrawerClose = () => {
      setDrawerOpen(false);
      setSelectedClient(null);
  };

  const handleOpenEdit = (id) => {
  
    setEditingClient(clients.find(dataItem=> dataItem.id === id)); 
    setDrawerOpen(false);
    setShowModal(true);
};


  const loadMore = () => setVisibleCount(prevCount => prevCount + tilesDisplayCount);

  
  
  /*
  const filteredClients = clients.filter(client =>
    columns.some(column => client[column.field] && client[column.field].toString().toLowerCase().includes(searchTerm.toLowerCase()))
  );
  */

  
  const filteredClients = clients.filter(client =>
    columns.some(column => {
        let value = client[column.field];

        let matchFound = value && value.toString().toLowerCase().trim().includes(searchTerm.toLowerCase().trim());

        if (matchFound == false)
        {
          if (column.field.endsWith('Id')) {
              const formatFunctionName = 'format' + column.field.replace(/Id$/, '').replace(/^\w/, c => c.toUpperCase());

              try
              {
                value = eval(`${formatFunctionName}("${value}")`);
                matchFound = value && value.toString().toLowerCase().trim().includes(searchTerm.toLowerCase().trim());
              } catch(errr){}
          }
        }

        return matchFound;

    })
  );
  

  const totalClients = filteredClients.length;


  return (
    <div
    style={{
      margin: '20px',
      backgroundImage: isMobile ? `url(${backgroundImageMobile})` : `url(${backgroundImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'top right',
      //backgroundSize: 'contain',
      //opacity: 0.1, // Adjust the opacity as needed
    }}
  >
      <Header title="Clients" subtitle="List of clients" />
      <Box m="0px 0 0px 0" pt="10px" display="flex" justifyContent="flex-start">
              <Button variant="contained" color="primary" sx={{ backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }} onClick={handleDeleteSelected} disabled={loading}>
                <RemoveCircleOutlineIcon /> &nbsp; Delete Selected
              </Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
              <Button variant="contained" color="primary" sx={{ backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }} onClick={handleOpenModal} disabled={loading}>
                <AddCircleOutlineIcon /> &nbsp; Add New
              </Button>
      </Box>

      <div style={{ paddingTop:'7px',display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {/*
        <div style={{ flex: '0 0 auto', textAlign: 'left', paddingLeft:'7px', fontSize:'11px' }}>
            COLUMNS FILTERS
        </div>
        */}
        <div style={{ margin: '0 auto', textAlign: 'center' }}>
          {/* You can put here any message you want to center*/}
        </div>
    </div>
    

    {!loading &&
    <div className="tile-wrapper">

    {filteredClients.slice(0, visibleCount).map((item, index) => ( 
          <Tile key={index} data={item} clients={clients} setDrawerOpen={setDrawerOpen} setShowModal={setShowModal} setEditingData={setEditingClient} handleDeleteSingleItem={handleDeleteSingleItem} setCollectionModalOpen={setCollectionModalOpen} setMissingCollections={setMissingCollections} deleteSelectionModel={deleteSelectionModel} setDeleteSelectionModel={setDeleteSelectionModel} />
         ))}


    </div>

     }

     
    <ClientDrawerModal
                        drawerOpen={drawerOpen}
                        handleDrawerClose={handleDrawerClose} 
                        handleArrowUpClick="" 
                        handleArrowDownClick=""
                        selectedClient={editingClient}
                        clients={clients} 
                        handleOpenEdit={handleOpenEdit}
                    />
                    
      <ClientInputModal isOpen={showModal} onClose={() => setShowModal(false)} onSave={handleSaveClient} client={editingClient} />

      <Dialog open={confirmOpen} onClose={handleCancelClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Confirm"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this client?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleCancelClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }}>
            No
          </Button>
          <Button onClick={handleConfirmClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

        <Dialog open={deleteConfirmOpen} onClose={handleCancelDelete} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Confirm Delete"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            
          
            {(selectedIdsToDelete.length > 0 && selectedIdsNotToDelete.length == 0) && 
              <div>Are you sure you want to delete the selected clients? </div>
            }

            {(selectedIdsToDelete.length > 0 && selectedIdsNotToDelete.length > 0) && 
              <div>
                The selected clients with ids: &nbsp; 
                <b>{selectedIdsNotToDelete.join(", ")}</b><br></br> 
                cannot be deleted because they are linked to other dependent records in the following components:<br></br> <br></br>
                <b>{deletionDependencies.join(", ")}</b>. 
                <br></br><br></br>

                However, the remaining clients with ids: &nbsp;
                <b>{selectedIdsToDelete.join(", ")}</b><br></br> 
                will be deleted If you select <b>YES</b>.<br></br><br></br>

                Do you want to proceed deleting <b>{selectedIdsToDelete.join(", ")}</b>? 
              </div>
            }

            {(selectedIdsToDelete.length == 0 && selectedIdsNotToDelete.length > 0) && 
              <div>
                The selected clients with ids: &nbsp;
                <b>{selectedIdsNotToDelete.join(", ")}</b><br></br> 
                cannot be deleted because they are linked to other dependent records in the following components:<br></br> <br></br>
                <b>{deletionDependencies.join(", ")}</b>. 
                <br></br><br></br>
                Please remove these dependencies before proceeding with the deletion.
                <br></br><br></br>

                <b><u>TIP</u>:</b> You can go to each of the components listed above and type each of the ids listed one by one in the search box to find the dependent records.
              </div>
            }

          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleCancelDelete} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }}>
          {selectedIdsToDelete.length > 0 ? 'No' : 'OK'}
          </Button>
          {selectedIdsToDelete.length > 0 &&
          <Button onClick={confirmDeleteSelected} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            Yes
          </Button>
          }
        </DialogActions>
      </Dialog>
      
      <Dialog open={collectionModalOpen} aria-labelledby="collection-modal-title" aria-describedby="collection-modal-description">
        <DialogTitle id="collection-modal-title">{"Missing Records"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="collection-modal-description">
            VAR_MISSING_RECORD_CHECKS
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" sx={{ backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }}  onClick={() => window.location.href = `/${missingCollections[0]}`} color="primary">
            Go to {missingCollections[0]}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteAlertOpen} onClose={handleAlertClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Alert"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            No clients selected for deletion.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleAlertClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={dependenciesAlertOpen} onClose={handleDependenciesAlertClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Delete Alert"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
          This client cannot be deleted because it is linked <br></br> 
          to other dependent records in the following components:<br></br> <br></br>
          <b>{deletionDependencies.join(", ")}</b>. 
          <br></br><br></br>

          Please remove these dependencies before proceeding with the deletion.          
          <br></br><br></br>

          <b><u>TIP</u>:</b> You can go to each of the components listed above and type <b>{deleteId}</b> in the search box to find the dependent records.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleDependenciesAlertClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showTestModeDialog} onClose={() => setShowTestModeDialog(false)}>
        <DialogTitle sx={{ backgroundColor: colors.greenAccent[700] }}>
          {"Test Mode Notice"}
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText>
            You are currently in <strong>Test Mode</strong>. This mode is intended for training and testing purposes only.
            <br /><br />
            If your intention is to add a live project record, please turn off test mode before proceeding.
          </DialogContentText>
          <Box mt={2}>
            <label>
              <input
                type="checkbox"
                checked={suppressTestModeWarning}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setSuppressTestModeWarning(checked);
                  localStorage.setItem('suppressTestModeSaveWarning', checked);
                }}
              />{" "}
              Don't show this message again when saving in test mode
            </label>
          </Box>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button
            onClick={() => setShowTestModeDialog(false)}
            sx={{
              backgroundColor: colors.greenAccent[600],
              color: colors.primary[100],
              '&:hover': { backgroundColor: colors.greenAccent[800] }
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>


     
  {loading ? (
      <Box display="flex" justifyContent="center" alignItems="center" height="100%">
        <CircularProgress size={150} style={{ marginTop:'200px',color: theme.palette.mode === "dark" ? 'white' : 'darkGray' }}  />
      </Box>
    ) : (  
    
      <div>
            {visibleCount < totalClients && 

                  
        <Box variant="contained" sx={{textAlign:'center'}}>
          <Button onClick={loadMore} variant="contained" sx={{ m: 2, alignSelf: 'center', backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }}>Load More</Button>
          <br></br>
          <br></br>
        </Box> 

        }

        {visibleCount >= totalClients && <br />}
        {clients.length === 0 && (
          <Box display="flex" alignItems="center" justifyContent="center" height="100%" sx={{ flexDirection: 'column' }}>
            <img src={noRecordImage} alt="No Data" style={{ width: 250, height: 250, opacity: 0.4 }} />
            <Typography variant="h4" sx={{ color: colors.grey[300] }}>You don't have any clients yet</Typography>
            <Typography variant="h5" sx={{ color: colors.grey[400], padding: '10px' }}>Click the <span style={{ color: '#dc0000', fontWeight: 'bold' }}>"ADD NEW"</span> button above</Typography>
          </Box>
        )}
    </div>
    )}


  {processing && (
    <Box
      position="fixed"
      top={0}
      left={0}
      width="100%"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      zIndex={2000}
      pointerEvents="none"
    >
      <CircularProgress size={120} style={{ color: theme.palette.mode === "dark" ? 'white' : 'darkGray' }} />
    </Box>
  )}

    </div>
  );
};

export default Clients;
